import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { GenericSimpleButton, GenericModal } from 'com-gyf-webcore-userinterfacecomponents';
import ProcessManager from "../../../../Common/Managers/ProcessManager";
let rutaVistaInstancia;
class BotonGuardarCancelar extends Component {
    constructor(props) {
        super(props);

    }


    onModalConfirmClick() {
        if (sessionStorage.getItem('PantallaCambios') == "true") {
            sessionStorage.removeItem('PantallaCambios')
        }
        $("#cancel-modal").modal("hide");
        window.location.href = "#" + rutaVistaInstancia;

    }

    onCancelUserClick(e) {
        if (sessionStorage.getItem('PantallaCambios') == "true") {
            e.preventDefault();
            $("#cancel-modal").modal({ backdrop: "static" });
        } else {
            $("#cancel-modal").modal("hide");
        }
    }

    render() {
        rutaVistaInstancia = ProcessManager.GetNextStep("NuevaInstanciaParametro", "ROUTE_TO_VISTA_INSTANCIA_PARAMETRO");
        if (this.props.atlas) {
            if (this.props.atlas.entidadId) {
                rutaVistaInstancia += "/" + this.props.atlas.entidadId;
            }
        }


        return (
            <div className="row bottom-separator-xs">
                <div className="contenedor-boton-aceptar-cancelar">
                    <div className="col-xs-12">
                    <button type="button" className={`btn-orange right-separator-xs ${this.props.huboError ? 'atlas__boton--deshabilitado' : ''}`} onClick={() => {
                        this.props.mostrarSpinner();
                        this.props.guardarNuevaInstanciaParametro();
                    }}>Guardar</button>
                        <Link onClick={(e) => this.onCancelUserClick(e)} to={rutaVistaInstancia} className="btn btn-secondary nivelarBtnCancelarGuardar">Cancelar</Link>
                    </div>
                </div>

                <GenericModal id="cancel-modal"
                    className="modal fade-out modal-center"
                    type="ALL_CUSTOM"
                    screenSize="modal-dialog modal-generic"
                    header={<h2 className="modal-title">Descartar Cambios</h2>}
                    footer={<div className="row">
                        <div className="col-xs-5">
                            <button type="button" className="btn-orange" onClick={() => this.onModalConfirmClick()}>Descartar Cambios</button>
                        </div>
                        <div className="col-xs-7">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        </div>
                    </div>}
                    body={<p>Se han realizado modificaciones, en caso de no guardarlos se perderán ¿Desea descartar los cambios?</p>}
                />

            </div>
        );
    }
}

export default BotonGuardarCancelar